/* ============================================================================
 * section-lo-product-child-main.js
 * Behaviour for sections/lo-product-child-main.liquid.
 * Resilient init: re-binds on shopify:section:load, cleans up on :unload.
 * Owns: gallery, qty +/-, variant selection, tabs, accordion, add-on AJAX.
 * ========================================================================== */

(function () {
  'use strict';

  var SELECTOR = '[data-section-type="lo-product-child-main"]';

  function $(scope, sel) { return scope.querySelector(sel); }
  function $$(scope, sel) { return Array.prototype.slice.call(scope.querySelectorAll(sel)); }

  function formatMoney(cents) {
    var out;
    // Motion's own formatter; adds the comma thousands separator per the
    // shop's money_format (e.g. $3,500). Defaults to theme.settings.moneyFormat.
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      out = theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    } else if (window.theme && typeof window.theme.formatMoney === 'function') {
      out = window.theme.formatMoney(cents);
    } else if (window.Shopify && Shopify.formatMoney) {
      out = Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    } else {
      out = '$' + (cents / 100).toFixed(2);
    }
    return out.replace(/\.00(?=\D|$)/, '');
  }

  /* ───── Cart count refresh (LO header + Motion's cart bubble) ───── */
  function refreshCartCount() {
    var routes = (window.theme && window.theme.routes) || {};
    var cartUrl = routes.cart_url || '/cart.js';
    if (cartUrl.indexOf('.js') === -1) cartUrl = cartUrl.replace(/\/$/, '') + '.js';

    return fetch(cartUrl, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return null;
        var count = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = ' (' + count + ')';
          if (count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
        document.querySelectorAll('[data-cart-bubble]').forEach(function (el) {
          el.textContent = count;
          if (count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart },
          bubbles: true
        }));
        return cart;
      })
      .catch(function () { return null; });
  }

  /* ───── Gallery ───── */
  function initGallery(container) {
    var gallery = $(container, '[data-gallery]');
    if (!gallery) return null;

    var slides    = $$(gallery, '[data-gallery-slide]');
    var thumbs    = $$(gallery, '[data-gallery-thumb]');
    var thumbStrip = $(gallery, '[data-gallery-thumbs]');
    var prev      = $(gallery, '[data-gallery-arrow="prev"]');
    var next      = $(gallery, '[data-gallery-arrow="next"]');
    if (slides.length < 2) return null;

    var index = 0;

    function scrollThumbIntoView(i) {
      if (!thumbStrip || !thumbs[i]) return;
      var thumbLi = thumbs[i].parentElement || thumbs[i];
      var stripRect = thumbStrip.getBoundingClientRect();
      var thumbRect = thumbLi.getBoundingClientRect();
      if (thumbRect.left < stripRect.left) {
        thumbStrip.scrollLeft -= (stripRect.left - thumbRect.left) + 4;
      } else if (thumbRect.right > stripRect.right) {
        thumbStrip.scrollLeft += (thumbRect.right - stripRect.right) + 4;
      }
    }

    function show(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      slides.forEach(function (s, n) {
        var on = n === i;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      index = i;
      scrollThumbIntoView(i);
    }

    function onPrev() { show(index - 1); }
    function onNext() { show(index + 1); }
    var thumbHandlers = thumbs.map(function (t, n) {
      var h = function () { show(n); };
      t.addEventListener('click', h);
      return h;
    });
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    function onSelectMedia(e) {
      var id = e.detail && e.detail.mediaId;
      if (id == null) return;
      for (var n = 0; n < slides.length; n++) {
        if (String(slides[n].getAttribute('data-media-id')) === String(id)) {
          show(n);
          return;
        }
      }
    }
    container.addEventListener('lo-gallery:select-media', onSelectMedia);

    return function destroy() {
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      thumbs.forEach(function (t, n) { t.removeEventListener('click', thumbHandlers[n]); });
      container.removeEventListener('lo-gallery:select-media', onSelectMedia);
    };
  }

  /* ───── Quantity +/- ───── */
  function initQty(container) {
    var input   = $(container, '[data-qty-input]');
    var display = $(container, '[data-qty-display]');
    var minus   = $(container, '[data-qty-minus]');
    var plus    = $(container, '[data-qty-plus]');
    if (!input || !display) return null;

    var min = parseInt(input.getAttribute('min') || '1', 10) || 1;

    function render(val) {
      input.value = String(val);
      display.textContent = String(val);
      if (minus) minus.disabled = val <= min;
    }

    function bump(delta) {
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = min;
      var next = current + delta;
      if (next < min) next = min;
      render(next);
    }

    var onMinus = function () { bump(-1); };
    var onPlus  = function () { bump(1); };

    if (minus) minus.addEventListener('click', onMinus);
    if (plus)  plus.addEventListener('click', onPlus);

    render(parseInt(input.value, 10) || min);

    return function destroy() {
      if (minus) minus.removeEventListener('click', onMinus);
      if (plus)  plus.removeEventListener('click', onPlus);
    };
  }

  /* ───── Variants ───── */
  function initVariants(container) {
    var form = $(container, '.lo-product-child-main__form');
    if (!form) return null;

    var dataEl = $(container, '[data-variants-json]');
    if (!dataEl) return null;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    if (!Array.isArray(variants) || variants.length === 0) return null;

    var fieldsets = $$(container, '[data-option-fieldset]');
    var hiddenId  = $(container, '[data-variant-id]');
    var priceEl   = $(container, '[data-price]');
    var compareEl = $(container, '[data-compare-price]');
    var atcBtn    = $(container, '[data-add-to-cart]');
    var atcText   = $(container, '[data-add-to-cart-text]');

    function selectedValues() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(values) {
      return variants.find(function (v) {
        return values.every(function (val, i) {
          if (val == null) return true;
          return v.options[i] === val;
        });
      }) || null;
    }

    function updateAvailability(currentValues) {
      fieldsets.forEach(function (fs, fsIndex) {
        var inputs = $$(fs, 'input[type="radio"]');
        inputs.forEach(function (input) {
          var probe = currentValues.slice();
          probe[fsIndex] = input.value;
          var hasAvailable = variants.some(function (v) {
            var match = probe.every(function (val, i) {
              if (val == null) return true;
              return v.options[i] === val;
            });
            return match && v.available;
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !hasAvailable);
        });
      });
    }

    function applyVariant() {
      var values = selectedValues();
      var v = findVariant(values);

      updateAvailability(values);

      if (!v) {
        if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }

      if (hiddenId) hiddenId.value = v.id;

      if (v.featured_media && v.featured_media.id != null) {
        container.dispatchEvent(new CustomEvent('lo-gallery:select-media', {
          detail: { mediaId: v.featured_media.id }
        }));
      }

      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.hidden = false;
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      if (atcBtn) {
        if (v.available) {
          atcBtn.removeAttribute('disabled');
          if (atcText) {
            atcText.textContent = atcText.getAttribute('data-default-text') || 'Add to cart';
          }
        } else {
          atcBtn.setAttribute('disabled', 'disabled');
          if (atcText) atcText.textContent = 'Sold out';
        }
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* IE-only failure, fine */ }
    }

    var handler = function () { applyVariant(); };
    var inputs = $$(container, '[data-option-input]');
    inputs.forEach(function (i) { i.addEventListener('change', handler); });

    applyVariant();

    return function destroy() {
      inputs.forEach(function (i) { i.removeEventListener('change', handler); });
    };
  }

  /* ───── Tabs ───── */
  function initTabs(container) {
    var tabs = $$(container, '[data-tab]');
    var panels = $$(container, '[data-tabpanel]');
    if (tabs.length === 0) return null;

    function activate(index) {
      tabs.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p, i) {
        var on = i === index;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
      });
    }

    var handlers = tabs.map(function (tab, i) {
      var onClick = function () { activate(i); };
      var onKey = function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var dir = e.key === 'ArrowRight' ? 1 : -1;
          var next = (i + dir + tabs.length) % tabs.length;
          activate(next);
          tabs[next].focus();
        } else if (e.key === 'Home') {
          e.preventDefault();
          activate(0);
          tabs[0].focus();
        } else if (e.key === 'End') {
          e.preventDefault();
          activate(tabs.length - 1);
          tabs[tabs.length - 1].focus();
        }
      };
      tab.addEventListener('click', onClick);
      tab.addEventListener('keydown', onKey);
      return { onClick: onClick, onKey: onKey };
    });

    return function destroy() {
      tabs.forEach(function (t, i) {
        t.removeEventListener('click', handlers[i].onClick);
        t.removeEventListener('keydown', handlers[i].onKey);
      });
    };
  }

  /* ───── Accordion ───── */
  function initAccordion(container) {
    var triggers = $$(container, '[data-acc-trigger]');
    var handlers = triggers.map(function (trig) {
      var handler = function () {
        var panel = document.getElementById(trig.getAttribute('aria-controls'));
        var expanded = trig.getAttribute('aria-expanded') === 'true';
        trig.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) {
          if (expanded) panel.setAttribute('hidden', '');
          else panel.removeAttribute('hidden');
        }
      };
      trig.addEventListener('click', handler);
      return handler;
    });

    return function destroy() {
      triggers.forEach(function (t, i) { t.removeEventListener('click', handlers[i]); });
    };
  }

  /* ───── Add-on AJAX (one-tap Add → Added ✓ toggle) ───── */
  function initAddons(container) {
    var buttons = $$(container, '[data-addon-add]');
    if (buttons.length === 0) return null;

    var routes = (window.theme && window.theme.routes) || {};
    var ADD_URL = routes.cart_add_url || '/cart/add.js';
    var CHANGE_URL = routes.cart_change_url || '/cart/change.js';

    function setLabel(btn, text) {
      var label = btn.querySelector('.lo-product-child-main__addon-add-label');
      if (label) { label.textContent = text; } else { btn.textContent = text; }
    }

    function setAdded(btn, lineKey) {
      btn.classList.add('is-added');
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('data-addon-line-key', lineKey || '');
      setLabel(btn, 'Added ✓');
    }

    function setNotAdded(btn) {
      btn.classList.remove('is-added');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('data-addon-line-key', '');
      setLabel(btn, 'Add');
    }

    function flashError(btn, fallbackLabel) {
      setLabel(btn, 'Try again');
      setTimeout(function () { setLabel(btn, fallbackLabel); }, 2000);
    }

    function add(btn) {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.classList.add('is-loading');
      setLabel(btn, 'Adding…');

      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', '1');

      fetch(ADD_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed (' + r.status + ')');
          return r.json();
        })
        .then(function (item) {
          btn.classList.remove('is-loading');
          setAdded(btn, item && item.key);
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: item, addToCartBtn: btn },
            bubbles: true
          }));
          refreshCartCount();
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          flashError(btn, 'Add');
          try { console.error('[lo-product-child-main] add-on add failed:', err); } catch (e) {}
        });
    }

    function remove(btn) {
      var lineKey = btn.getAttribute('data-addon-line-key');
      if (!lineKey) { setNotAdded(btn); return; }
      btn.classList.add('is-loading');
      setLabel(btn, 'Removing…');

      fetch(CHANGE_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Remove from cart failed (' + r.status + ')');
          return r.json();
        })
        .then(function () {
          btn.classList.remove('is-loading');
          setNotAdded(btn);
          document.dispatchEvent(new CustomEvent('ajaxProduct:removed', {
            detail: { addToCartBtn: btn },
            bubbles: true
          }));
          refreshCartCount();
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          flashError(btn, 'Added ✓');
          try { console.error('[lo-product-child-main] add-on remove failed:', err); } catch (e) {}
        });
    }

    var handlers = buttons.map(function (btn) {
      var handler = function () {
        if (btn.classList.contains('is-loading') || btn.hasAttribute('disabled')) return;
        if (btn.classList.contains('is-added')) {
          remove(btn);
        } else {
          add(btn);
        }
      };
      btn.addEventListener('click', handler);
      return handler;
    });

    return function destroy() {
      buttons.forEach(function (b, i) { b.removeEventListener('click', handlers[i]); });
    };
  }

  /* ───── Main product form (AJAX add to cart) ───── */
  function initMainForm(container) {
    var form = $(container, '.lo-product-child-main__form');
    if (!form) return null;
    var btn = $(form, '[data-add-to-cart]');
    var labelEl = btn ? $(btn, '[data-add-to-cart-text]') : null;
    var routes = (window.theme && window.theme.routes) || {};
    var ADD_URL = routes.cart_add_url || '/cart/add.js';

    function setLabel(text) {
      if (labelEl) labelEl.textContent = text;
      else if (btn) btn.textContent = text;
    }

    function defaultLabel() {
      return (labelEl && labelEl.getAttribute('data-default-text')) || 'Add to Cart';
    }

    var handler = function (e) {
      e.preventDefault();
      if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');
      var origLabel = defaultLabel();
      setLabel('Adding…');

      fetch(ADD_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (body) {
              throw new Error((body && (body.description || body.message)) || 'Add to cart failed (' + r.status + ')');
            }, function () {
              throw new Error('Add to cart failed (' + r.status + ')');
            });
          }
          return r.json();
        })
        .then(function (item) {
          btn.classList.remove('is-loading');
          setLabel('Added ✓');
          setTimeout(function () { setLabel(origLabel); }, 1600);
          var qtyInput = form.querySelector('[name="quantity"]');
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          if (window.theme && typeof window.theme.showCartNotification === 'function') {
            window.theme.showCartNotification(item, qty);
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: item, addToCartBtn: btn },
            bubbles: true
          }));
          refreshCartCount();
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          setLabel('Try again');
          setTimeout(function () { setLabel(origLabel); }, 2000);
          try { console.error('[lo-product-child-main] main add failed:', err); } catch (e2) {}
        });
    };

    form.addEventListener('submit', handler);
    return function destroy() { form.removeEventListener('submit', handler); };
  }

  /* ───── Sticky-gallery scroll-jack (clone of whats-included pattern) ───── */
  function initScrollJack(container) {
    var prefersReduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return null;

    var track    = container.querySelector('[data-pc-track]');
    var viewport = container.querySelector('[data-pc-viewport]');
    var frame    = container.querySelector('[data-pc-frame]');
    var list     = container.querySelector('[data-pc-list]');
    if (!track || !viewport || !frame || !list) return null;

    var raf = 0;
    var lastProgress = -1;

    function isDesktop() {
      return window.matchMedia('(min-width: 1025px)').matches;
    }

    function compute() {
      raf = 0;
      if (!isDesktop()) {
        list.style.transform = '';
        track.style.removeProperty('--lo-pc-scroll-distance');
        return;
      }

      var listHeight = list.scrollHeight;
      var frameHeight = frame.clientHeight;
      var maxOffset = Math.max(0, listHeight - frameHeight);

      if (Math.abs(maxOffset - parseFloat(track.dataset.pcOffset || -1)) > 1) {
        track.dataset.pcOffset = maxOffset;
        track.style.setProperty('--lo-pc-scroll-distance', maxOffset + 'px');
      }

      var rect = track.getBoundingClientRect();
      var scrollDistance = track.offsetHeight - viewport.offsetHeight;
      if (scrollDistance <= 0) {
        list.style.transform = 'translate3d(0,0,0)';
        return;
      }

      var scrolled = -rect.top;
      var progress = Math.max(0, Math.min(1, scrolled / scrollDistance));

      if (Math.abs(progress - lastProgress) < 0.001) return;
      lastProgress = progress;

      list.style.transform = 'translate3d(0,' + (-(maxOffset * progress)).toFixed(2) + 'px,0)';
    }

    function schedule() {
      if (raf) return;
      raf = window.requestAnimationFrame(compute);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    var ro = null;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(schedule);
      ro.observe(list);
    }

    compute();

    return function destroy() {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (ro) ro.disconnect();
      if (raf) window.cancelAnimationFrame(raf);
      list.style.transform = '';
      track.style.removeProperty('--lo-pc-scroll-distance');
    };
  }

  /* ───── Per-instance lifecycle ───── */
  function init(container) {
    if (!container || container.dataset.loInited === 'true') return;
    container.dataset.loInited = 'true';

    var cleanups = [
      initGallery(container),
      initQty(container),
      initVariants(container),
      initTabs(container),
      initAccordion(container),
      initMainForm(container),
      initAddons(container),
      initScrollJack(container)
    ].filter(Boolean);

    container._loCleanup = function () {
      cleanups.forEach(function (fn) { try { fn(); } catch (e) {} });
      container.dataset.loInited = '';
    };
  }

  function destroy(container) {
    if (!container) return;
    if (typeof container._loCleanup === 'function') container._loCleanup();
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.matches && e.target.matches(SELECTOR)) init(e.target);
    else if (e.target.querySelectorAll) initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.matches && e.target.matches(SELECTOR)) destroy(e.target);
    else if (e.target.querySelectorAll) e.target.querySelectorAll(SELECTOR).forEach(destroy);
  });
})();
